import { render, staticRenderFns } from "./DictTypeList.vue?vue&type=template&id=60769d18&"
import script from "./DictTypeList.vue?vue&type=script&lang=js&"
export * from "./DictTypeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports